// assets/bmss.js
(() => {
  // Prevent double-init if Horizon/GemPages inject multiple times
  if (window.__BMSS_INIT__) return;
  window.__BMSS_INIT__ = true;

  const toNum = (v) => {
    const n = parseFloat(String(v ?? "").replace(/[^0-9.]/g, ""));
    return Number.isFinite(n) ? n : NaN;
  };

  const clampInt = (n) => {
    n = Math.floor(Number(n));
    if (!Number.isFinite(n) || n < 1) n = 1;
    return n;
  };

  const getQty = () => {
    // Prefer your bridge
    if (window.FAQty && typeof window.FAQty.getQty === "function") {
      return clampInt(window.FAQty.getQty());
    }
    // Fallback
    const el =
      document.querySelector("form[action*='/cart/add'] input[name='quantity']") ||
      document.querySelector("input[name='quantity']");
    return clampInt(toNum(el?.value));
  };

  const parseTiers = (box) =>
    [...box.querySelectorAll("[data-tier]")]
      .map((el) => ({
        el,
        qty: toNum(el.getAttribute("data-qty")),
        pct: toNum(el.getAttribute("data-pct")),
      }))
      .filter((t) => Number.isFinite(t.qty) && Number.isFinite(t.pct))
      .sort((a, b) => a.qty - b.qty);

  const updateBMSSUI = (box, qty) => {
    const tiers = parseTiers(box);
    if (!tiers.length) return;

    // clear
    tiers.forEach((t) => {
      t.el.classList.remove("is-reached");
      t.el.classList.remove("is-current");
      t.el.classList.remove("active"); // keep compatibility with your older CSS
    });

    // reached
    tiers.forEach((t) => {
      if (qty >= t.qty) t.el.classList.add("is-reached");
    });

    // current = highest reached
    let current = null;
    for (const t of tiers) if (qty >= t.qty) current = t;

    if (current) {
      // support both naming styles
      current.el.classList.add("is-current");
      current.el.classList.add("active");
    }

    // next tier
    let next = null;
    for (const t of tiers) {
      if (qty < t.qty) {
        next = t;
        break;
      }
    }

    // message (ONLY the first one, avoids duplicates ever)
    const msg = box.querySelector("[data-bmss-message]");
    if (msg) {
      if (next) {
        const add = Math.max(0, Math.ceil(next.qty - qty));
        msg.textContent = `Add ${add} more box${add === 1 ? "" : "es"} to unlock ${next.pct}% off.`;
        msg.style.display = "";
      } else if (current) {
        msg.textContent = `You’ve unlocked ${current.pct}% off.`;
        msg.style.display = "";
      } else {
        msg.style.display = "none";
      }
    }

    // optional sqft helper if present
    const sqftEl = box.querySelector("[data-bmss-sqft]");
    const sqftPerBox = toNum(box.getAttribute("data-box-sqft"));
    if (sqftEl && Number.isFinite(sqftPerBox)) {
      const total = Math.round(qty * sqftPerBox * 10) / 10;
      sqftEl.textContent = `Estimated coverage: ${total} sq ft (${qty} box${qty === 1 ? "" : "es"}).`;
      sqftEl.style.display = "";
    }
  };

  const updateAll = () => {
    const qty = getQty();
    document.querySelectorAll("[data-bmss]").forEach((box) => updateBMSSUI(box, qty));
  };

  // Expose for quick testing
  window.BMSS = window.BMSS || {};
  window.BMSS.updateAll = updateAll;

  // Run now + after GemPages hydration
  const init = () => {
    updateAll();
    setTimeout(updateAll, 200);
    setTimeout(updateAll, 800);
    setTimeout(updateAll, 1600);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Update when bridge announces qty changed
  document.addEventListener("fa:quantity-updated", updateAll);

  // Horizon partial navigation: URL change without full reload
  let lastUrl = location.href;
  setInterval(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(updateAll, 100);
      setTimeout(updateAll, 400);
      setTimeout(updateAll, 1200);
    }
  }, 300);

  // Ultra-safe fallback (light polling)
  setInterval(updateAll, 500);
})();
